var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconConfirmed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "48px",
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Confirmed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invite-registered_verify-email",
    transform: "translate(-694.000000, -224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmed",
    transform: "translate(682.500000, 212.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    fill: "#00A099",
    cx: 36,
    cy: 36,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5803254,27.8337795 L33.711,37.566 L28.4203961,32.2754741 C27.5601417,31.4152198 26.2025666,31.4152198 25.3423181,32.2754682 L24.2701864,33.3476 C23.4099379,34.2078485 23.4099379,35.5654236 24.2701864,36.425672 L32.2538305,44.2559746 L32.5597623,44.4788857 C32.8383074,44.6230962 33.0867495,44.6970754 33.3846569,44.7467266 C33.6665683,44.7937118 34.496089,44.7456952 34.8202197,44.6416546 C34.9995933,44.5840786 35.2353269,44.4368727 35.5450947,44.1935034 L36.0674814,43.7555104 L47.7260277,31.9884346 C48.5897171,31.1248043 48.5918388,29.7672209 47.7305292,28.9059112 L46.6583974,27.8337795 C45.7981489,26.973531 44.4405738,26.973531 43.5803254,27.8337795 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconConfirmed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Confirmed.951a60cb36065cf4e9c076d613f9139d.svg";